import { render, staticRenderFns } from "./email.vue?vue&type=template&id=9a766a38&scoped=true&"
var script = {}
import style0 from "./email.vue?vue&type=style&index=0&id=9a766a38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a766a38",
  null
  
)

export default component.exports